module.exports = __webpack_public_path__ + "img/formula_green.44a91aa2.png";